(function () {
  'use strict';

  window.NavigationUtils = window.NavigationUtils || {};

  NavigationUtils.navigateTo = function (route) {
    if (window.APP && window.APP.goto) {
      window.APP.goto(route);
    } else {
      window.location.href = '/' + route;
    }
  };

  NavigationUtils.navigateToRoom = function (roomKey) {
    NavigationUtils.navigateTo('r/' + encodeURIComponent(roomKey));
  };

  NavigationUtils.navigateToAI = function (aiName) {
    NavigationUtils.navigateTo('ai-chat/' + encodeURIComponent(aiName));
  };

  NavigationUtils.goBack = function () {
    if (window.APP && window.APP.stepBack) {
      window.APP.stepBack();
    } else if (window.history && window.history.length > 1) {
      window.history.back();
    } else {
      NavigationUtils.navigateTo('');
    }
  };

  NavigationUtils.canHandleRoute = function (route) {
    return window.APP && window.APP.router && window.APP.router.routes;
  };

  NavigationUtils.getCurrentRoute = function () {
    var path = window.location.pathname;
    if (path.startsWith('/')) {
      path = path.substring(1);
    }
    return path;
  };

  NavigationUtils.redirectToLogin = function (nextUrl) {
    var loginUrl = '/login';
    if (nextUrl) {
      loginUrl += '?next=' + encodeURIComponent(nextUrl);
    } else {
      var currentUrl = window.location.pathname + window.location.search;
      loginUrl += '?next=' + encodeURIComponent(currentUrl);
    }
    window.location.href = loginUrl;
  };
})();
